import React, {PropsWithChildren} from 'react'
import Dialog from '../Dialog'
import DialogContent from '../Dialog/DialogContent'

type ConfirmDialogProps = Omit<React.ComponentProps<typeof Dialog>, 'children'> & {
  maxWidth: string
  overflowY: string
}

const ConfirmDialog: React.FC<PropsWithChildren<ConfirmDialogProps>> = ({children, maxWidth, overflowY, ...props}) => {
  return (
    <Dialog {...props}>
      <DialogContent
        position="relative"
        display="flex"
        flexDirection="column"
        width="100%"
        gap="8px"
        maxWidth={maxWidth}
        overflow="hidden"
        overflow-y={overflowY}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDialog
